import UserGroups from './UserGroups';

export default UserGroups;
